module.exports = __webpack_public_path__ + "static/media/index-float-icon.31818138.png";